import FeeStructurePage from './FeeStructurePage';

export default FeeStructurePage;
